import { RealEstateFeatures } from '../../../../../@types/types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'
import React from 'react'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

export const shortTermAccommodationRentEstateFeaturesList = [
  RealEstateFeatures.BALCONY_TERRACE,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.ELEVATOR,
  RealEstateFeatures.SHARED_GARDEN,
  RealEstateFeatures.BASEMENT,
]

export const shortTermAccommodationRentEstateFeatures = () =>
  estateFeatures([...shortTermAccommodationRentEstateFeaturesList, RealEstateFeatures.NON_SMOKER])

export const createShortTermAccommodationRentEstateFeaturesForWebView = (label: React.ReactNode, className: string) =>
  estateFeatures(shortTermAccommodationRentEstateFeaturesList, label, className)

export const shortTermAccommodationRentBuildingTypeOptions = [
  BuildingTypeOption.FLAT,
  BuildingTypeOption.HOUSE,
  BuildingTypeOption.ROOM,
  BuildingTypeOption.APARTMENT,
]
